<app-layout>
    <section class="user-status">
        <div class="user-status__row">
            <div class="user-status__item">
                <font-awesome-icon class="animate-bounce text-4xl text-yellow-500 mb-5 user-status__icon" icon="clock"></font-awesome-icon>
                <h2 class="user-status__title">{{ $t('Your payment is being processed') }}</h2>
                <p class="mb-8 leading-relaxed">{{ $t('Once we receive a confirmation from our Payment Provider, the system will adjust your wallet balance.') }}</p><div class="flex justify-center">
                <nav-button-link :href="route('reports.deposits.fiat')">
                    <span>{{ $t('Check payment status') }}</span>
                </nav-button-link>
            </div>
            </div>
        </div>
    </section>
</app-layout>
